import { ref } from "vue";
import { getLocation } from "./getLocation";

// Shared location state that lives as long as the page. A fix survives the handoff from the splash
// to the scanner. The splash starts the request right after the camera prompt, while the scanner is
// still loading.
//
// This ref stays reactive, so a fix that lands late can still reach a report. Readers that copy the
// value once will miss it. The scan events in VideoAuth read it each time, so they pick up a late
// fix. A report sent within the first seconds of the camera opening may still go out without one.
const coordinates = ref({});
let requested = false;

// Ask for the GPS permission once. This does not block. It fills `coordinates` when the fix lands
// and leaves it empty if the user declines or the device cannot answer. The report then falls back
// to an IP based location.
function requestLocation() {
  if (requested) {
    return;
  }
  requested = true;
  getLocation()
    .then(({ latitude, longitude, accuracy }) => {
      coordinates.value = { latitude, longitude, accuracy };
    })
    .catch(() => {});
}

function useCoordinates() {
  return coordinates;
}

export { requestLocation, useCoordinates };
